import './sentry';
import './favicon';
import ReactDOM from "react-dom/client";
import { Provider } from 'react-redux';
import { store } from '@nxsys/store';
import App from "./App.tsx";
import reportWebVitals from "./reportWebVitals";

// Log unhandled promise rejections for visibility in console.
// Do NOT call event.preventDefault() — Sentry needs the event to propagate.
window.addEventListener('unhandledrejection', (event) => {
  console.error('[Unhandled Promise Rejection]', event.reason);
});

const container = document.getElementById('root');
if (!container) {
  throw new Error("Root container not found. Make sure the element with id 'root' exists in your HTML.");
}
const root = ReactDOM.createRoot(container);
root.render(
  // <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  // </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
